// Copyright (c) 2023 Deere & Company

const duplicatePinPlateFilterOptions = [
    ['pin']

];

export default duplicatePinPlateFilterOptions;



// WEBPACK FOOTER //
// ./src/tcsm/wip/services/duplicate-pin-plate-filter-options.js